<p [hidden]="showButtonFilter">
    <button class="btn btn-default" type="button" data-toggle="collapse" data-target="#collapseExample"
        aria-expanded="false" aria-controls="collapseExample">
        <i class="fas fa-filter"></i> Filtrar
    </button>
</p>
<div class="collapse" id="collapseExample">
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-outline card-lightblue">
                        <div class="card-body p-2">

                            <!-- Linha 1   -->
                            <div class="row">

                                <div class="col-md-3 form-group">
                                    <label for="selectReferencia" class="mb-1">Referência</label>
                                    <ng-select [(ngModel)]="filtroModel.tipo">
                                        <ng-option *ngFor="let tipo of tipos" [value]="tipo.codigo">{{
                                            tipo.descricao
                                            }}
                                        </ng-option>
                                    </ng-select>
                                </div>

                                <div class="col-md-3 form-group">
                                    <label for="prazoFinal" class="mb-1">Prazo Final</label>
                                    <input [(ngModel)]="filtroModel.prazoFinal" type="date" id="prazoFinal"
                                        class="form-control form-control-sm" />
                                </div>

                                <div class="col-md-3 form-group">
                                    <label for="numeroOsa" class="mb-1">Número Doc. Associado</label>
                                    <input type="text" id="numeroOsa" [(ngModel)]="filtroModel.numeroOsa"
                                        class="form-control form-control-sm" />
                                </div>

                                <div class="col-md-3 form-group">
                                    <label for="status" class="mb-1">Status</label>
                                    <ng-select [(ngModel)]="filtroModel.status">
                                        <ng-option *ngFor="let status of status" [value]="status.codigo">{{
                                            status.descricao }}
                                        </ng-option>
                                    </ng-select>
                                </div>

                            </div>

                            <!-- Linha 2   -->
                            <div class="row">

                                <div class="col-md-3 form-group">
                                    <label for="selectUnidadeGestora" class="mb-1">UG</label>
                                    <ng-select [(ngModel)]="filtroModel.unidadeGestoraId">
                                        <ng-option *ngFor="let element of unidadesGestoras" [value]="element.id">{{
                                            element.sigla }}
                                        </ng-option>
                                    </ng-select>
                                </div>


                                <div class="col-md-6 form-group">
                                    <label for="selectTipoAuditoria" class="mb-1">Tipo</label>
                                    <ng-select [(ngModel)]="filtroModel.tipoAuditoriaId">
                                        <ng-option *ngFor="let element of tiposAuditoria" [value]="element.id">{{
                                            element.nome }}
                                        </ng-option>
                                    </ng-select>
                                </div>

                            </div>

                            <mat-toolbar>
                                <mat-toolbar-row style="
										padding: 0px;
										justify-content: flex-end;
									">
                                    <button type="button" class="btn btn-success btn-sm mr-3"
                                        (click)="buscarComFiltro()">
                                        <i class="fas fa-search"></i> Pesquisar
                                    </button>
                                </mat-toolbar-row>
                            </mat-toolbar>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>